/** Side of a node a handle sits on. Values match React Flow v11's `Position` enum. */
export enum Position {
  Left = 'left',
  Top = 'top',
  Right = 'right',
  Bottom = 'bottom',
}
